import { Auth } from 'aws-amplify';

const hasActiveSession = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return !!user;
  } catch (err) {}
  return false;
};

export default hasActiveSession;
